/** @jsx jsx */
import { jsx } from "@emotion/react";
import { gridStyle } from "./GridStyles.js";

const Row = ({ children }) => <div css={gridStyle.row}>{children}</div>;

const Col = ({ children }) => <div css={gridStyle.col}>{children}</div>;

export { Row, Col };
